<template>
    <v-dialog persistent max-width="500px" v-model="show">
        <v-card>
            <v-card-title class="headline">Action</v-card-title>
            <v-card-text v-if="actionState == 'confirm'">
                <p>You are about to start work on a <b>{{ action.title }}</b>.</p>
                <p v-if="eligibleTasks">There are {{ eligibleTasks.length - 1 }} tasks that require you to do this. Which one would you like to complete?</p>
                <v-select :items="eligibleTasks" label="Task" item-text="title" item-value="id" v-model="selectedTask"></v-select>
                <v-alert type="warning" v-if="selectedTask == null">
                    <b>You have selected no task.</b> Completing this action will cost action points and tasks in your todo list will not be checked off.
                </v-alert>
                <v-alert type="info" v-if="selectedTask != null">
                    This action will check off the '{{ tasks[selectedTask].title }}' task from your todo list<span v-if="!action.alwaysSuccess">if you are successful</span>.
                </v-alert>
                <p>
                    This will cost <b>{{ action.actionPoints }} action points</b>
                    <span v-if="!action.alwaysSuccess"> but there is a chance that you might not succeed</span>!
                </p>
            </v-card-text>
            <v-card-text class="centered" v-if="actionState == 'wait'">
                <v-progress-circular indeterminate color="primary" :size="50" class="mb-5"></v-progress-circular>
                <p class="body-1">Performing action...</p>
            </v-card-text>
            <v-card-text v-if="actionState == 'fail'">
                <p class="text-center"><v-icon x-large color="white" class="icon-bg icon-bg-red">mdi-close</v-icon></p>
                <p>You did not succeed this time! If you have enough action points left, you can try again.</p>
            </v-card-text>
            <v-card-text v-if="actionState == 'success'">
                <p class="text-center"><v-icon x-large color="white" class="icon-bg icon-bg-green">mdi-check</v-icon></p>
                <p class="body-1"><b>Congratulations!</b> You were successful in completing your action.</p>
                <p>Remember to let others know how you did.</p>
            </v-card-text>
            <v-card-text v-if="message">
                <v-alert type="info">{{ message }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click.stop="close()" v-if="actionState == 'confirm'">Cancel</v-btn>
                <v-btn color="primary" text @click.stop="continueButton()" v-if="actionState != 'wait'">Continue</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { slugify } from '../util';

export default {
    props: {
        value: Boolean,
        action: Object
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit("input", value);
            }
        },
        eligibleTasks() {
            var output = [
                {
                    id: null,
                    title: "== NO TASK =="
                }
            ];
            if (!this.tasks) { return output; }
            const actionSlug = slugify(this.action.title);
            const taskList = Object.values(this.tasks).filter(task => task.action == actionSlug && !task.complete);
            return output.concat(taskList);
        },
        ...mapState({
            tasks: state => state.tasks
        })
    },
    data: () => ({
        actionState: "confirm",
        message: null,
        selectedTask: null
    }),
    methods: {
        continueButton() {
            if (this.actionState == 'confirm') {
                this.$socket.client.emit("do_action", {
                    action: this.action,
                    task: this.selectedTask
                });
                this.actionState = 'wait'
            } else if (this.actionState == 'fail' || this.actionState == 'success') {
                this.close();
            }
        },
        close() {
            this.actionState = 'confirm';
            this.message = null;
            this.show = false;
            this.selectedTask = null;
        }
    },
    sockets: {
        do_action_response(res) {
            if (res.success) {
                this.actionState = 'success';
            } else {
                this.actionState = 'fail';
            }

            this.message = res.message || null;
        }
    }
}
</script>

<style scoped>
.centered {
    text-align: center;
}

.icon-bg {
    border-radius: 50%;
    padding: 10px;
}

.icon-bg-green {
    background: #4caf50;
}

.icon-bg-red {
    background: #f44346;
}
</style>
